'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroBadge = function (_Component) {
  _inherits(NitroBadge, _Component);

  function NitroBadge() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NitroBadge);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NitroBadge.__proto__ || Object.getPrototypeOf(NitroBadge)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      if (typeof _this.props.action === 'function') {
        _this.props.action(_this.props.label);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NitroBadge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          variant = _props.variant,
          label = _props.label,
          icon = _props.icon,
          iconVariant = _props.iconVariant,
          action = _props.action,
          size = _props.size,
          textColor = _props.textColor;


      var badgeContent = _react2.default.createElement(
        _styles.BadgeText,
        {
          className: className,
          size: size
        },
        icon && _react2.default.createElement(_nitroIcon2.default, {
          variant: iconVariant,
          name: icon,
          alignment: true,
          size: size - 2,
          right: label ? 4 : 0
        }),
        _react2.default.createElement(
          'span',
          null,
          label
        )
      );

      if (action) {
        return _react2.default.createElement(
          _styles.BadgeButton,
          _extends({
            icon: icon,
            label: label,
            onClick: this.handleClick,
            outline: !variant
          }, this.props),
          badgeContent
        );
      }

      return _react2.default.createElement(
        _styles.Badge,
        _extends({
          icon: icon,
          label: label,
          outline: !variant
        }, this.props),
        badgeContent
      );
    }
  }]);

  return NitroBadge;
}(_react.Component);

NitroBadge.propTypes = {
  variant: _propTypes2.default.string,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.number.isRequired]),
  size: _propTypes2.default.number,
  top: _propTypes2.default.number,
  icon: _propTypes2.default.string,
  action: _propTypes2.default.func,
  align: _propTypes2.default.oneOf(['left', 'right', 'center']),
  bold: _propTypes2.default.bool,
  iconVariant: _propTypes2.default.string,
  className: _propTypes2.default.string,
  textColor: _propTypes2.default.string
};

NitroBadge.defaultProps = {
  variant: 'base2',
  size: 16,
  align: 'right',
  textColor: 'white'
};

exports.default = NitroBadge;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-badge/NitroBadge.js
// module id = 2885
// module chunks = 4